<!-- Font Awesome section start -->
<section id="font-awesome-icons">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Font Awesome Icons</div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="feather-icons overflow-hidden">
              <div class="row">
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-glass"></i></div>
                  <label class="fonticon-classname">fa-glass</label>
                  <label class="fonticon-unit">f000</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-music"></i></div>
                  <label class="fonticon-classname">fa-music</label>
                  <label class="fonticon-unit">f001</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-search"></i></div>
                  <label class="fonticon-classname">fa-search</label>
                  <label class="fonticon-unit">f002</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-envelope-o"></i></div>
                  <label class="fonticon-classname">fa-envelope-o</label>
                  <label class="fonticon-unit">f003</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-heart"></i></div>
                  <label class="fonticon-classname">fa-heart</label>
                  <label class="fonticon-unit">f004</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-star"></i></div>
                  <label class="fonticon-classname">fa-star</label>
                  <label class="fonticon-unit">f005</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-star-o"></i></div>
                  <label class="fonticon-classname">fa-star-o</label>
                  <label class="fonticon-unit">f006</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-user"></i></div>
                  <label class="fonticon-classname">fa-user</label>
                  <label class="fonticon-unit">f007</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-film"></i></div>
                  <label class="fonticon-classname">fa-film</label>
                  <label class="fonticon-unit">f008</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-th-large"></i></div>
                  <label class="fonticon-classname">fa-th-large</label>
                  <label class="fonticon-unit">f009</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-th"></i></div>
                  <label class="fonticon-classname">fa-th</label>
                  <label class="fonticon-unit">f00a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-th-list"></i></div>
                  <label class="fonticon-classname">fa-th-list</label>
                  <label class="fonticon-unit">f00b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-check"></i></div>
                  <label class="fonticon-classname">fa-check</label>
                  <label class="fonticon-unit">f00c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-times"></i></div>
                  <label class="fonticon-classname">fa-times</label>
                  <label class="fonticon-unit">f00d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-search-plus"></i></div>
                  <label class="fonticon-classname">fa-search-plus</label>
                  <label class="fonticon-unit">f00e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-search-minus"></i></div>
                  <label class="fonticon-classname">fa-search-minus</label>
                  <label class="fonticon-unit">f010</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-power-off"></i></div>
                  <label class="fonticon-classname">fa-power-off</label>
                  <label class="fonticon-unit">f011</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-signal"></i></div>
                  <label class="fonticon-classname">fa-signal</label>
                  <label class="fonticon-unit">f012</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-cog"></i></div>
                  <label class="fonticon-classname">fa-cog</label>
                  <label class="fonticon-unit">f013</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-trash-o"></i></div>
                  <label class="fonticon-classname">fa-trash-o</label>
                  <label class="fonticon-unit">f014</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-home"></i></div>
                  <label class="fonticon-classname">fa-home</label>
                  <label class="fonticon-unit">f015</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-file-o"></i></div>
                  <label class="fonticon-classname">fa-file-o</label>
                  <label class="fonticon-unit">f016</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-clock-o"></i></div>
                  <label class="fonticon-classname">fa-clock-o</label>
                  <label class="fonticon-unit">f017</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-road"></i></div>
                  <label class="fonticon-classname">fa-road</label>
                  <label class="fonticon-unit">f018</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-download"></i></div>
                  <label class="fonticon-classname">fa-download</label>
                  <label class="fonticon-unit">f019</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-arrow-circle-o-down"></i></div>
                  <label class="fonticon-classname">fa-arrow-circle-o-down</label>
                  <label class="fonticon-unit">f01a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-arrow-circle-o-up"></i></div>
                  <label class="fonticon-classname">fa-arrow-circle-o-up</label>
                  <label class="fonticon-unit">f01b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-inbox"></i></div>
                  <label class="fonticon-classname">fa-inbox</label>
                  <label class="fonticon-unit">f01c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-play-circle-o"></i></div>
                  <label class="fonticon-classname">fa-play-circle-o</label>
                  <label class="fonticon-unit">f01d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-repeat"></i></div>
                  <label class="fonticon-classname">fa-repeat</label>
                  <label class="fonticon-unit">f01e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-refresh"></i></div>
                  <label class="fonticon-classname">fa-refresh</label>
                  <label class="fonticon-unit">f021</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-list-alt"></i></div>
                  <label class="fonticon-classname">fa-list-alt</label>
                  <label class="fonticon-unit">f022</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-lock"></i></div>
                  <label class="fonticon-classname">fa-lock</label>
                  <label class="fonticon-unit">f023</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-flag"></i></div>
                  <label class="fonticon-classname">fa-flag</label>
                  <label class="fonticon-unit">f024</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-headphones"></i></div>
                  <label class="fonticon-classname">fa-headphones</label>
                  <label class="fonticon-unit">f025</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-volume-off"></i></div>
                  <label class="fonticon-classname">fa-volume-off</label>
                  <label class="fonticon-unit">f026</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-volume-down"></i></div>
                  <label class="fonticon-classname">fa-volume-down</label>
                  <label class="fonticon-unit">f027</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-volume-up"></i></div>
                  <label class="fonticon-classname">fa-volume-up</label>
                  <label class="fonticon-unit">f028</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-qrcode"></i></div>
                  <label class="fonticon-classname">fa-qrcode</label>
                  <label class="fonticon-unit">f029</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-barcode"></i></div>
                  <label class="fonticon-classname">fa-barcode</label>
                  <label class="fonticon-unit">f02a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-tag"></i></div>
                  <label class="fonticon-classname">fa-tag</label>
                  <label class="fonticon-unit">f02b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-tags"></i></div>
                  <label class="fonticon-classname">fa-tags</label>
                  <label class="fonticon-unit">f02c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-book"></i></div>
                  <label class="fonticon-classname">fa-book</label>
                  <label class="fonticon-unit">f02d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-bookmark"></i></div>
                  <label class="fonticon-classname">fa-bookmark</label>
                  <label class="fonticon-unit">f02e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-print"></i></div>
                  <label class="fonticon-classname">fa-print</label>
                  <label class="fonticon-unit">f02f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-camera"></i></div>
                  <label class="fonticon-classname">fa-camera</label>
                  <label class="fonticon-unit">f030</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-font"></i></div>
                  <label class="fonticon-classname">fa-font</label>
                  <label class="fonticon-unit">f031</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-bold"></i></div>
                  <label class="fonticon-classname">fa-bold</label>
                  <label class="fonticon-unit">f032</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-italic"></i></div>
                  <label class="fonticon-classname">fa-italic</label>
                  <label class="fonticon-unit">f033</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-text-height"></i></div>
                  <label class="fonticon-classname">fa-text-height</label>
                  <label class="fonticon-unit">f034</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap"><i class="fa fa-text-width"></i></div>
                  <label class="fonticon-classname">fa-text-width</label>
                  <label class="fonticon-unit">f035</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <h5 class="text-right mt-2">
            <a href="http://fontawesome.io/icons/" target="_blank">Get More Font Awesome Icons Here</a>
          </h5>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Font Awesome section end -->
